import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import clsx from 'clsx'
import env from 'config/env'
import ResponsiveImage from 'components/images/responsive-image'
import Typo from 'constants/typography'
import styles from './style.scss'

class LookbookHeader extends React.Component {
  renderImage(imageId) {
    const imgHost = env.IMG_HOST
    const imageFullPath = `${imgHost}img/lookbooks/${imageId}.jpg`
    const { lookbook, isPhone } = this.props
    return (
      <ResponsiveImage
        alt={lookbook.title}
        laptopAndUp="90vw"
        imgRatio={isPhone ? 0.75 : 0.535}
        src={imageFullPath}
      />
    )
  }

  render() {
    const { isPhone, lookbook, t } = this.props

    if (!lookbook) {
      return null
    }

    const { banner } = lookbook
    const titleStyles = {
      color: banner.caption_color || null,
      right: banner.align === 'right' ? '0' : null,
      left: banner.align === 'left' ? '0' : null,
    }
    const hasTitle = !!(banner.title || banner.description)

    return (
      <div className={clsx('lb-header__wrapper', { 'has-title': hasTitle })}>
        <style jsx>{styles}</style>
        {this.renderImage(banner[`image_cover${isPhone ? '_mobile' : ''}`])}
        {hasTitle && (
          <div
            className="lb-header__group"
            style={isPhone ? null : titleStyles}
          >
            <span
              className={clsx('lb-header__title', isPhone ? Typo.h4 : Typo.h3)}
            >
              {t(banner.title)}
            </span>
            <span className={clsx('lb-header__desc', Typo.body2)}>
              {t(banner.description)}
            </span>
          </div>
        )}
      </div>
    )
  }
}

LookbookHeader.defaultProps = {
  lookbook: undefined,
  isPhone: undefined,
  t: undefined,
}

LookbookHeader.propTypes = {
  lookbook: PropTypes.shape({
    title: PropTypes.string,
    banner: PropTypes.shape({
      align: PropTypes.string,
      caption: PropTypes.string,
      title: PropTypes.string,
      description: PropTypes.string,
      caption_color: PropTypes.string,
    }),
  }),
  isPhone: PropTypes.bool,
  t: PropTypes.func,
}

const Extended = translate('global')(LookbookHeader)

export { LookbookHeader }

export default connect(
  /* istanbul ignore next */
  (state) => ({
    isPhone: state.device.isPhone,
  }),
)(Extended)
